import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SelectListItem } from '../lib/select/select-property';
import { UserProfile_Search, User } from '../model/user-profile';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { UserProfileService } from '../services/user-profile.service';
import { FilterDataService } from '../services/filter-data.service';
import { AppService } from '../services/app.service';
import { ReturnClass } from 'projects/Shared-Lib/model/search-result';
import { TableSetting } from 'projects/Shared-Lib/component/table/table-class';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
  providers: [UserProfileService]
})
export class UserProfileComponent implements OnInit {
  @ViewChild('acc') acc: NgbAccordionItem; //link to ngAfterViewInit().

  model: UserProfile_Search;
  displayedColumns: string[] = ['userid', 'useraccount', 'username', 'email', 'isenabled', 'updatedby', 'updateddatetime'];
  // 傳入 DataTable 資料之變數
  TableData: ReturnClass;
  currentRoute: string;
  sampleMenu: any[];

  userPermission: any;
  TableSetting: TableSetting;

  CanCreate: boolean = true;
  CanDelete: boolean = true;
  CanEdit: boolean = true;

  // PDI 1989 Start
  ddlLocatedROoptions: SelectListItem[];
  AllEntities: SelectListItem[];
  //ddlLocatedEntitiesPlaceholder: string;
  ddlLocatedEntitiesDisableStatus: boolean; //
  ddlLocatedEntityOptions: SelectListItem[];
  // PDI 1989 End

  constructor(private app: AppService, private router: Router,
    private filterService: FilterDataService, private UserService: UserProfileService) {

    this.model = new UserProfile_Search();

    this.TableSetting = new TableSetting();
    this.TableSetting.CanUpdate = true;
    this.TableSetting.CanDelete = true;
    this.TableSetting.IdColumnName = 'UserId';
    this.TableSetting.ItemTitle = (element: User) => {
      return `${element.UserName}`;
    };
    this.TableSetting.CorrespondTableHeard = [
      { columnDef: 'UserAccount', header: 'User Account', cell: (element: User) => `${element.UserAccount}` },
      { columnDef: 'UserName', header: 'User Name', cell: (element: User) => `${element.UserName}` },
      { columnDef: 'EMail', header: 'Mail Address', cell: (element: User) => `${element.EMail}` },
      { columnDef: 'IsEnabled', header: 'IsEnabled', cell: (element: User) => `${element.IsEnabled == 'True' ? "Y" : "N"}` },
      { columnDef: 'UpdatedBy', header: 'Updated By', cell: (element: User) => `${element.UpdatedBy}` },
      { columnDef: 'UpdatedDateTime', header: 'Updated DateTime', cell: (element: User) => `${element.UpdatedDateTime.ToDateTimeString()}` },
    ];

    this.userPermission = this.app.currentResource.subscribe(data => {
      this.TableSetting.CanUpdate = data.CanUpdate;
      this.TableSetting.CanDelete = data.CanDelete;
      this.CanCreate = data.CanCreate;
    });
  }

  ngOnInit() {
    setTimeout(() => this.app.SetLoadingState(true), 0);
    this.currentRoute = this.router.url;
    this.Search();
  }

  ngAfterViewInit() {
    // The ngb-accordion object can only be accessed after the page has initialized : setTimeout(() => this.acc.expandAll(), 0);
  }

  OnDataSrvEnd() {
    setTimeout(() => this.app.SetLoadingState(false), 0);
  }

  Search() {
    setTimeout(() => this.app.SetLoadingState(true), 0);
    if (this.filterService.HasUsed) {
      let LasttimeSearchInfo = this.filterService.GetSearchInfo();
      if (LasttimeSearchInfo.Filter) {
        this.model.filter = LasttimeSearchInfo.Filter;
      }
    }

    this.filterService.ChangeSearchInfo(this.currentRoute, this.model.filter);

    this.UserService.GetUsers(this.model.filter)
      .subscribe(res => {
        this.model.DataResult =
          this.TableData = {
            draw: this.model.filter.PageIndex,
            pagingSize: this.model.filter.PageSize,
            recordsTotal: res.Result.TotalCount,
            recordsFiltered: res.Result.TotalCount,
            data: res.Result.DataList
          };
      }, err => {

      }, () => {
        this.OnDataSrvEnd();
      });
  }

  // call from child component : data-source-table -> change page size function
  onChangePageInfo(PageInfo: any) {
    this.model.filter.PageSize = PageInfo.PageSize;
    this.model.filter.PageIndex = PageInfo.CurrentPage;
    this.Search();
  }

  onChangeTableInfo(TableInfo: any) {
    this.model.filter.SortBy = TableInfo.SortBy;
    this.model.filter.IsAsc = TableInfo.IsAsc;
    this.Search();
  }

  Delete(DeleteGuid: any) {
    this.UserService.DeleteUser(DeleteGuid.UserId)
      .subscribe(data => {
        if (data.Success) {
          this.Search();
        }
      });
  }
}
